import { FC } from "react";
import { observer } from "mobx-react-lite";
import { EmptyContainer } from "@/components/styling/empty/empty-container";
import { EmptyText } from "@/components/styling/empty/empty-text";

interface SessionsListPageListEmptyProps {}

export const SessionsListPageListEmpty: FC<SessionsListPageListEmptyProps> = observer(() => {
  return (
    <EmptyContainer>
      <EmptyText>No sessions yet.</EmptyText>
    </EmptyContainer>
  );
});
